<template>
    <main>
        <div class="article-wrapper">
            <article>
                <div class="article-bread">
                    <router-link to="/">首页</router-link>
                    >
                    <router-link to="/product">产品介绍</router-link>
                    >
                    <span>{{type}}</span>
                </div>
                <h2>{{type}}</h2>
            </article>
            <el-table
                    :data="datas"
                    style="width: 70%;margin: auto"
                    border
                    :header-cell-style="{'background-color': '#909399','color':'#FFFFFF'}"
                    :row-class-name="tableRowClassName">
                <el-table-column prop="name" label="产品名称" width="150" align="center"></el-table-column>
                <el-table-column prop="xh" label="产品类型" width="150" align="center"></el-table-column>
                <el-table-column prop="appearance" label="外观" width="150" align="center"></el-table-column>
                <el-table-column prop="sz" label="色泽(Fe-Co)" width="80" align="center"></el-table-column>
                <el-table-column prop="gtf" label="固体分 (%)" width="80" align="center"></el-table-column>
                <el-table-column prop="nd" label="粘度25℃, 格式管" width="85" align="center"></el-table-column>
                <el-table-column prop="qz" label="羟值100%理论值/玻璃化温度" width="115" align="center"></el-table-column>
                <el-table-column prop="ph" label="PH/PH值" width="80" align="center"></el-table-column>
                <el-table-column prop="sj" label="酸价" width="80" align="center"></el-table-column>
                <el-table-column prop="rj" label="溶剂" width="80" align="center"></el-table-column>
                <el-table-column prop="content" label="特点及用途"  align="center"></el-table-column>
            </el-table>
        </div>
    </main>
</template>

<script>

    import qs from 'qs';
    export default {
        name: 'ProductItem',
        data() {
            return {
                isMobile: false,
                showDetail: false,
                datas:[],
                type: this.$route.params.type,
            }
        },
        mounted() {
            this.loadData();
            const width = window.innerWidth
            if (width < 480) {
                this.isMobile = true
            }
        },

        methods: {
            loadData() {
                let params = {
                    type: this.type
                }
                this.$axios.post('/findProductbyType', qs.stringify(params)).then(res => {
                    this.datas = res.data;
                }).catch(res => {
                    alert("数据获取失败")
                })
            },
            tableRowClassName({row, rowIndex}) {
                if (rowIndex %2 == 1) {
                    return 'warning-row';
                }
                return '';
            },

        },

    }
</script>

<style lang="less">

    .el-table .warning-row {
        background: #E4E7ED;
    }


</style>